module.exports = __webpack_public_path__ + "assets/img/user-icon_um.ba89df3d.svg";